// Shopify Draft Order Integration
// Creates a draft order via backend API and redirects to Shopify checkout

/**
 * Create Shopify checkout via Draft Order API
 * @param {Object} quote - The calculated quote data
 * @param {Array} doors - The doors/parts array
 * @param {string} region - Shipping region
 * @param {Object} contactInfo - Customer contact info (name, email, phone)
 * @param {string} apiUrl - Backend API URL
 * @returns {Promise<Object>} - Response with checkout_url
 */
export async function createShopifyCheckout(quote, doors, region, contactInfo, apiUrl) {
  const response = await fetch(`${apiUrl}/create-shopify-checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      contact_name: contactInfo.name,
      contact_email: contactInfo.email,
      contact_phone: contactInfo.phone || '',
      quote_data: quote,
      doors: doors,
      region: region
    })
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to create checkout');
  }
  
  return response.json();
}

/**
 * Format quote for display in checkout
 */
export function formatQuoteForCheckout(quote, doors) {
  return {
    items: quote.doors.map((door, i) => ({
      name: door.style,
      quantity: door.quantity,
      dimensions: `${door.width.toFixed(2)}" × ${door.height.toFixed(2)}"`,
      sqft: door.total_sqft.toFixed(2),
      price: door.line_total.toFixed(2)
    })),
    subtotal: quote.subtotal.toFixed(2),
    setupFee: quote.setup_fee.toFixed(2),
    packagingFee: quote.packaging_fee.toFixed(2),
    shipping: quote.shipping.toFixed(2),
    total: quote.total.toFixed(2)
  };
}
